import {DataList, DataSearch, Detail, Email} from '../../../components'
import {PartnerRepository} from '../../../repositories'
import {toDateTimeString} from '../../../global/utils/functions'

import './index.css'

const headers = [
    {name: 'Họ tên', className: 'partner-name'},
    {name: 'Ref', className: 'partner-ref'},
    {name: '% shopplan', className: 'partner-percent-shoplan'},
    {name: '% app', className: 'partner-percent-app'},
    {name: '% theme', className: 'partner-percent-theme'},
    {name: 'Email', className: 'partner-email'},
    {name: 'Ngày đăng ký', className: 'partner-sign-date'},
]

export const PartnerList = () => {

    const fetchPartners = async (page, pageSize, search, filter) => {
        const response = await PartnerRepository.GetListPartner(page, pageSize, search)
        const list = response?.data?.data?.map(p => ({
            fullName: <Detail to={`/partners/${p.id}`}>{`${p.lastName} ${p.firstName}`}</Detail>,
            ref: p.ref,
            percentShopplan: `${p.payment_SharePercent_ShopPlan}%`,
            percentApp: `${p.payment_SharePercent_App}%`,
            percentTheme: `${p.payment_SharePercent_Theme}%`,
            email: <Email to={p.userName}/>,
            signDate: toDateTimeString(p.createdDate),
        }))
        const rawData = response?.data?.data
        const total = response?.data?.totalRecord
        return {list, rawData, total}
    }

    return (
        <div className='partner-list-wrapper'>
            <div className='data-list-container'>
                <div className='flex stretch mb-md'>
                    <DataSearch usedBy='partner-list'
                                placeholder='Tìm kiếm theo Id, ref, email, họ tên của khách hàng'/>
                </div>
                <DataList usedBy='partner-list' headers={headers} loadData={fetchPartners}/>
            </div>
        </div>
    )
}
